<i18n>
{
  "de": {
    "andImmediately": "und bekomme sofort",
    "getExclusiveAccess": "Zugriff auf exklusive Inhalte",
    "signUpNow": "Registriere dich jetzt",
    "hey": "Hi",
    "follow": "Folge",
    "availableProducts": "Produkte",
    "availableSubscriptions": "Mitgliedschaften"
  },
  "en": {
    "andImmediately": "and immediately",
    "getExclusiveAccess": "get access to all exclusive posts.",
    "signUpNow": "Sign up now",
    "hey": "Hey",
    "follow": "Follow",
    "availableProducts": "Products",
    "availableSubscriptions": "Memberships"
  }
}
</i18n>

<template>
  <section
    v-if="artist"
    class="hero is-medium is-primary"
  >
    <div
      v-if="!isAuthenticated"
      class="hero-body"
    >
      <div class="container has-text-centered">
        <h3 class="title is-2">
          {{ $t('follow') }} <strong>{{ artist.nickname }}</strong>, {{ $t('andImmediately') }}
        </h3>
        <h4 class="subtitle is-4">
          {{ $t('getExclusiveAccess') }}
        </h4>

        <a
          href="#"
          class="button is-outlined is-white is-large mt-20"
          @click="showFollowerModal = true"
        >
          <strong>{{ $t('signUpNow') }}</strong>
        </a>
      </div>
      <modal
        v-if="showFollowerModal"
        :backdropClose="true"
        :defaultHeader="false"
        :defaultFooter="true"
        @close="closeFollowModal"
      >
        <div slot="body">
          <div class="is-overlay">
            <section class="scale-hack">
              <div class="content">
                <div
                  class="
                    modal-card
                    animated
                    slideInDown
                    login-modal
                    pt-10
                    pl-10
                    pr-10
                  "
                >
                  <follower-login @logged="closeFollowModal" />
                </div>
              </div>
            </section>
          </div>
        </div>
      </modal>
    </div>
    <div
      v-else-if="user.nickname"
      class="hero-body"
    >
      <div class="container has-text-centered">
        <h3 class="title is-2">
          {{ $t('hey') }} <strong>{{ user.nickname }}</strong>! {{ $t('follow') }} <strong>{{ artist.nickname }}</strong>, {{
            $t('andImmediately') }}
        </h3>
        <h4 class="subtitle is-4">
          {{ $t('getExclusiveAccess') }}
        </h4>
        <div class="cta-purchasables">
          <nuxt-link
            v-if="artist.products.length"
            :to="localePath({
              name: 'id-products',
              params: { id: artist.urlAlias }
            })
            "
            class="button is-outlined is-white is-large mt-20"
          >
            <strong>{{
              $t('availableProducts') }}</strong>
          </nuxt-link>
          <nuxt-link
            v-if="artist.rewards.length"
            :to="localePath({
              name: 'id-rewards',
              params: { id: artist.urlAlias }
            })
            "
            class="button is-outlined is-white is-large mt-20"
          >
            <strong>{{
              $t('availableSubscriptions') }}</strong>
          </nuxt-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import followerLogin from '~/components/follower-login'
import modal from '~/components/modal'

export default {
  props: ['user', 'artist', 'isAuthenticated'],
  components: { modal, followerLogin },
  data: () => ({
    showFollowerModal: false
  }),
  methods: {
    closeFollowModal() {
      this.showFollowerModal = false
    }
  }
}
</script>

<style lang="scss">
@media only screen and (max-width: 1023px) {
  .cta-purchasables {
    .button+.button {
      margin-left: 0px !important;
    }
  }
}
</style>
